import { decodeLocation } from "./encode-decode-location";
import { isKeyword } from "./is-keyword";

export function extractLocationsFromUrl(urlString: string): string[] {
	const segments = urlString.toLowerCase().split("-");
	const inIndex = segments.indexOf("in");

	if (inIndex !== -1 && inIndex + 1 < segments.length) {
		const locationSegments: string[] = [];
		let i = inIndex + 1;
		while (i < segments.length && !isKeyword(segments[i])) {
			locationSegments.push(segments[i]);
			i++;
		}
		if (locationSegments.length > 0) {
			return [decodeLocation(locationSegments.join("-"))];
		}
	}
	return [];
}
